import {
  StorePaymentLogCrumb,
  StorePaymentLogTitle,
} from '@/features/payment-management/store-payment-logs/individual-store-logs/components/StorePaymentLogTitle';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/payment-management/store-payment-log/$storeId')({
  component: RouteComponent,
  loader: ({ params }) => {
    const storeId = params['storeId'];
    return {
      crumb: <StorePaymentLogCrumb storeId={storeId} />,
      title: <StorePaymentLogTitle storeId={storeId} />,
    };
  },
  errorComponent: ({ error }) => {
    return <div>{error.message}</div>;
  },
});

function RouteComponent() {
  return (
    <div>
      <Outlet />
    </div>
  );
}
